// extracted by mini-css-extract-plugin
module.exports = {"specification":"product-specification_specification__9Lrcb"};